import {
  calculateFinances,
  UserData,
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const InvestmentPlanWealth = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text:
        '<br><h5>Would you like to do investments yourself?<br />Or would you like serious expert help on financial planning?</h5>',
    },
    {
      type: 'cards',
      cards: [
        {
          title: 'Get Expert Help - Financial Planning',
          returns: '18-25',
          doubledIn:
            'Our financial planning experts will handle your investments end to end',
          link: '/s/financial-planning',
        },
        {
          title: 'Do It Yourself - Aggressive Growth',
          returns: '15.3',
          doubledIn: (user: UserData) => {
            const taxData = calculateFinances(user);
            const aggressivePlan = calculateSipFutureValue(
              taxData.sipAmount,
              25,
              15
            );
            return `
            Rs. ${
              taxData.sipAmount
            } invested every month can become up to Rs. ${formatRupeeLiteral(
              aggressivePlan
            )} in ${taxData.aggressiveYears} years`;
          },
          link: '/save/plan/26',
          highlighted: true,
          planId: 26,
        },
      ],
    },
    {
      type: 'text',
      text: () => {
        return `<br/>
        <small class="light">
          Whatever you choose, ClearTax will always help you with your investments every step of the way!
        </small>`;
      },
    },
  ],
};

export default InvestmentPlanWealth;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanWealth.ts